import Vue from 'vue';

export function setQuickMoveIns(state, value) {
  state.quickMoveIns = value;
}

export function setQuickMoveInAttribute(state, payload) {
  const { index, field, value } = payload;
  const quickMoveIn = state.quickMoveIns[index];
  quickMoveIn[field] = value;
  Vue.set(state.quickMoveIns, index, quickMoveIn);
}

export function setFilter(state, payload) {
  const { field, value } = payload;
  state.filters[field] = value;
}
